export const EXPIRES_IN = 30;
export const ITEMS_TO_STORE = 10;
export const ITEMS_TO_SHOW = 10;
export const PRODUCTS_TO_SHOW = 3;
